import {Country} from "@/store/api/countryApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface CountryState {
    countries: Country[];
}

const initialState: CountryState = {
    countries: [],
}

const countrySlice = createSlice({
    name: "countries",
    initialState,
    reducers: {
        setCountries: (state, action: PayloadAction<Country[]>) => {
            state.countries = action.payload;
        },
        clearCountries: (state) => {
            state.countries = [];
        }
    }
})


export const { setCountries, clearCountries } = countrySlice.actions;
export default countrySlice.reducer;

